import React, { createContext, useContext, ReactNode } from 'react'
import { useErrorReporter } from 'app/core/utils/error-reporting'

interface ErrorReportingContextType {
  reportError: (error: Error, additionalContext?: Record<string, unknown>) => Promise<void>
}

const ErrorReportingContext = createContext<ErrorReportingContextType | null>(null)

export const useErrorReporting = () => {
  const context = useContext(ErrorReportingContext)
  if (!context) {
    throw new Error('useErrorReporting must be used within an ErrorReportingProvider')
  }
  return context
}

interface ErrorReportingProviderProps {
  children: ReactNode
}

export const ErrorReportingProvider: React.FC<ErrorReportingProviderProps> = ({ children }) => {
  const { reportError } = useErrorReporter()
  
  return (
    <ErrorReportingContext.Provider value={{ reportError }}>
      {children}
    </ErrorReportingContext.Provider>
  )
}